// @ts-nocheck

// libs
import axios from "src/libs/axios";
import useSWR from "swr";

// types
import { TClinicDetails } from "src/types";

// consts
import { ENDPOINTS } from "src/constants/endpoints";

const {
  GET: { clinics },
} = ENDPOINTS;

// eslint-disable-next-line import/prefer-default-export
export const useClinic = (id: number, defaultData: any) => {
  const initialData = defaultData ? { initialData: { data: defaultData } } : null;
  // pass null for canceling request
  const { data, error } = useSWR(id ? `${clinics}/${id}` : null, axios, initialData);

  return {
    clinic: data?.data,
    isLoading: !error && !data,
    isError: error,
  };
};
